/**
 * Language options
 */
export enum Language {
  ENGLISH = "english",
  ARABIC = "arabic",
  KURDISH = "kurdish"
}

/**
 * Array of all language values for easy iteration
 */
export const LANGUAGE_VALUES = Object.values(Language);

/**
 * Human-readable labels for languages
 */
export const LANGUAGE_LABELS: Record<Language, string> = {
  [Language.ENGLISH]: "English",
  [Language.ARABIC]: "Arabic", 
  [Language.KURDISH]: "Kurdish"
};